import { WasteGasParams } from '@/api/EmissionReportModel'
import Big from 'big.js'

export default function calculateWasteGasImportedEmissions(params: WasteGasParams) {
  return Big(params.volume || 0)
    .times(params.netCalorificValue || 0)
    .div(1000)
    .times(params.emissionFactor || 0)
}
